import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImportMessageService {

  set messages(msgs: { row: string, message: string }[]) {
    localStorage.setItem('importResults', JSON.stringify(msgs));;
  }

  get messages(): { row: string, message: string }[] {
    return JSON.parse(localStorage.getItem('importResults') || '');
  }
}
